import { Slider, Typography, Box } from "@mui/material";
import React, { useEffect, useState, useCallback, useRef } from "react";
import Plot from 'react-plotly.js';
import { useWebSocketConnection } from "../../services/connectionContext/connectionContext";

function valuetext(value) {
    return `${value}m`;
}

const marks = [
    { value: 0, label: '0m' },
    { value: 4, label: '4m' },
    { value: 12, label: '12m' },
    { value: 40, label: '40m' },
];

// const scaleThreshold = (x, threshold) => {
//     let th = parseFloat(threshold);
//     let fx = 7. / ((x + 2.) / 10.);
//     return fx + th;
// };

export const TargetListPlot = React.memo(({ title, socketTargetsEvent }) => {
    const { eventEmitter } = useWebSocketConnection();

    // Hier wird der tatsächlich angezeigte State für Plotly gespeichert
    const [targetList, setTargetList] = useState([
        { x: [], y: [], type: 'scattergl', mode: 'markers' },
        { x: [], y: [], type: 'scattergl', mode: 'markers' },
        { x: [], y: [], type: 'scattergl', mode: 'markers' },
    ]);

    const [value, setValue] = useState([0.0, 12.0]);

    // CHANGED: Ref zum Puffern der Daten.
    const targetListRef = useRef([
        { x: [], y: [], type: 'scattergl', mode: 'markers' },
        { x: [], y: [], type: 'scattergl', mode: 'markers' },
        { x: [], y: [], type: 'scattergl', mode: 'markers' },
    ]);

    // CHANGED: append_list schreibt nun direkt in targetListRef.current
    const append_list = useCallback((msg) => {
        if (msg && msg.header?.timestamp_read) {
            const currentRef = [...targetListRef.current];
            currentRef.forEach((trace, i) => {
                let newValue = msg.targets[i];
                if (newValue === 0) {
                    newValue = -1;
                }

                let newX = [...trace.x, msg.header.timestamp_read];
                let newY = [...trace.y, newValue];

                // 512 Punkte Limit oder Zeitlimit
                if (newX.length > 256) {
                    newX.shift();
                    newY.shift();
                }

                trace.x = newX;
                trace.y = newY;
            });
            targetListRef.current = currentRef;
        }
    }, []);

    useEffect(() => {
        eventEmitter.on(socketTargetsEvent, append_list);

        // CHANGED: Hier der Intervall für den State-Update
        const intervalId = setInterval(() => {
            setTargetList(targetListRef.current);
        }, 100); // 100ms = 10 Hz

        return () => {
            eventEmitter.off(socketTargetsEvent, append_list);
            clearInterval(intervalId);
        }
    }, [eventEmitter, socketTargetsEvent, append_list]);

    const handleChange = useCallback((event, newValue) => {
        setValue(newValue);
    }, []);

    // const thresholdChange = useCallback((event) => {
    //     const newThreshold = parseFloat(event.target.value);
    //     dispatch({ type: "radar:threshold", payload: { threshold: newThreshold } });
    //     setThreshold(newThreshold);
    // }, [dispatch]);

    return (
        <Box>
            <Typography>
                {title}
            </Typography>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <Slider
                    style={{ height: "360px", marginLeft: 5 }}
                    orientation="vertical"
                    value={value}
                    onChange={handleChange}
                    valueLabelDisplay="auto"
                    aria-labelledby="range-slider"
                    getAriaValueText={valuetext}
                    marks={marks}
                    max={40}
                    step={0.1}
                />

                <Plot
                    style={{ flexGrow: 1, height: "500px", width: "90%", minHeight: 400 }}
                    data={targetList}
                    layout={{
                        paper_bgcolor: 'rgba(0,0,0,0)',
                        plot_bgcolor: 'rgba(0,0,0,0)',
                        showlegend: true,
                        legend: { orientation: "h" },
                        xaxis: { showgrid: true, showline: true, gridwidth: 1, gridcolor: '#bbbbbb' },
                        yaxis: { range: value, showgrid: true, showline: true, gridwidth: 1, gridcolor: '#bbbbbb' },
                    }}
                    useResizeHandler={true}
                />
            </div>
        </Box>
    );
});
